module.exports = __webpack_public_path__ + "img/bg_box.d61f21f9.png";